import { useEffect, useRef } from "react";
import { useSocket } from "../../Context/SocketContext";

export const useSocketListener = (eventName, handler, dependencies = []) => {
  const { socket } = useSocket();
  const handlerRef = useRef(handler);
  const cleanupRef = useRef(null);

  // Update the handler ref when it changes
  useEffect(() => {
    handlerRef.current = handler;
  }, [handler]);

  useEffect(() => {
    if (!socket || !eventName) return;

    // Wrapper that always calls the latest handler
    const eventHandler = (...args) => {
      handlerRef.current?.(...args);
    };

    socket.on(eventName, eventHandler);
    cleanupRef.current = () => socket.off(eventName, eventHandler);

    return cleanupRef.current;
  }, [socket, eventName, ...dependencies]);

  // Cleanup on unmount
  useEffect(() => {
    return () => cleanupRef.current?.();
  }, []);
};
